var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('h2',[_vm._v("PROFESSIONAL FEES")]),_c('h4',[_vm._v("As distinct from Surgeon and Anesthesiologist's Fees, fees paid to licensed medical professionals including but not limited to an Occupational Therapist, Physiotherapist, Attending Physician's visits or Pathologists.")])])
}]

export { render, staticRenderFns }